(() => {
  if (window.divanoFlyToCart) return;

  window.divanoFlyToCart = (options) => {
    try {
      const { source, image, delay = 0, allowInCart = false } = options;
      const start = () => {
        try {
          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return false;
          if (!window.customElements?.get('fly-to-cart')) return false;
          if (!allowInCart && (document.querySelector('#MainContent')?.dataset.template?.split('.')[0] === 'cart' || /\/cart\/?$/.test(window.location.pathname))) return false;
          if (!(source instanceof Element) || !source.isConnected || (!allowInCart && source.closest('cart-drawer-component, .cart-drawer'))) return false;
          const cartIcon = document.querySelector('.header-actions__cart-icon');
          if (!cartIcon || typeof image !== 'string' || !image.trim()) return false;
          if (!source.getClientRects().length) return false;
          const rect = source.getBoundingClientRect();
          if (rect.width <= 0 || rect.height <= 0) return false;
          const anchor = document.createElement('div');
          anchor.setAttribute('aria-hidden', 'true');
          Object.assign(anchor.style, { position: 'fixed', left: `${rect.left}px`, top: `${rect.top}px`, width: `${rect.width}px`, height: `${rect.height}px`, opacity: '0', pointerEvents: 'none' });
          document.body.appendChild(anchor);
          setTimeout(() => anchor.remove(), 2000);

          const flight = document.createElement('fly-to-cart');
          flight.classList.add('fly-to-cart--main');
          flight.style.setProperty('background-image', `url(${image})`);
          flight.style.setProperty('--start-opacity', '0');
          flight.source = anchor;
          flight.destination = cartIcon;
          const inModal = allowInCart && source.closest('dialog:modal');
          if (inModal) {
            if (typeof flight.showPopover !== 'function') return false;
            flight.setAttribute('popover', 'manual');
            Object.assign(flight.style, { margin: '0', padding: '0', border: '0', right: 'auto', bottom: 'auto' });
          }
          document.body.appendChild(flight);
          if (inModal) {
            try { flight.showPopover(); } catch { flight.remove(); return false; }
          }
          return true;
        } catch { return false; }
      };
      if (delay > 0) {
        setTimeout(start, delay);
        return true;
      }
      return start();
    } catch { return false; }
  };

  window.divanoHighlightCartLine = (options) => {
    let observer;
    let quietTimer;
    let deadlineTimer;
    const stop = () => {
      observer?.disconnect();
      clearTimeout(quietTimer);
      clearTimeout(deadlineTimer);
    };
    try {
      const variantId = String(options.variantId || '');
      if (!/^\d+$/.test(variantId)) return;
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const roots = [...new Set([...document.querySelectorAll('cart-items-component')].map((cart) =>
        cart.closest('cart-drawer-component, .shopify-section') || cart.parentElement
      ).filter(Boolean))];
      if (!roots.length) return;
      const highlighted = new Map();
      const tint = 'oklch(0.96 0.005 30)';
      const visible = (element) => {
        const rect = element.getBoundingClientRect();
        return element.isConnected && element.getClientRects().length && rect.width > 0 && rect.height > 0 &&
          getComputedStyle(element).visibility === 'visible';
      };
      const highlight = () => {
        try {
          roots.forEach((root) => {
            root.querySelectorAll('cart-items-component .cart-items__table').forEach((list) => {
              if (!visible(list)) return;
              const row = [...list.querySelectorAll('.cart-items__table-row[data-key]')].find((line) =>
                line.dataset.key.split(':')[0] === variantId
              );
              if (!row || !visible(row) || typeof row.animate !== 'function') return;
              const previous = highlighted.get(root);
              if (previous && (previous.row === row || previous.count >= 2)) return;

              const rect = row.getBoundingClientRect();
              let top = 0;
              let left = 0;
              let bottom = window.innerHeight;
              let right = window.innerWidth;
              for (let parent = row.parentElement; parent; parent = parent.parentElement) {
                const style = getComputedStyle(parent);
                const bounds = parent.getBoundingClientRect();
                if (/(auto|scroll|hidden|clip)/.test(style.overflowY)) {
                  top = Math.max(top, bounds.top + parent.clientTop);
                  bottom = Math.min(bottom, bounds.top + parent.clientTop + parent.clientHeight);
                }
                if (/(auto|scroll|hidden|clip)/.test(style.overflowX)) {
                  left = Math.max(left, bounds.left + parent.clientLeft);
                  right = Math.min(right, bounds.left + parent.clientLeft + parent.clientWidth);
                }
              }
              if (rect.top < top || rect.bottom > bottom || rect.left < left || rect.right > right) {
                row.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: reducedMotion ? 'instant' : 'smooth' });
              }
              row.animate([
                { backgroundColor: tint },
                { backgroundColor: reducedMotion ? tint : 'transparent' },
              ], { duration: 1200, easing: 'ease-out' });
              highlighted.set(root, { row, count: (previous?.count || 0) + 1 });
            });
          });
        } catch { stop(); }
      };
      observer = new MutationObserver(() => {
        clearTimeout(quietTimer);
        quietTimer = setTimeout(highlight, 150);
      });
      roots.forEach((root) => observer.observe(root, { childList: true, subtree: true, attributes: true, characterData: true }));
      quietTimer = setTimeout(highlight, 150);
      deadlineTimer = setTimeout(stop, 3000);
    } catch { stop(); }
  };
})();
